// JavaScript Document

/**
 * Check if the alert exists
 */
const ALERT = document.querySelector(".alert-block");

if (ALERT) {
    /**
     * Open the alert immediately if it was not previously hidden
     */
    if (sessionStorage.getItem("alert-hidden") !== "true") {
        ALERT.classList.add("weblinx-alert-block--state-active");
    }

    /**
     * Find the alert button
     */
    const BUTTON = ALERT.querySelector(".alert__button");

    /**
     * On BUTTON click, remove ALERT `weblinx-alert-block--state-active` and store the interaction in sessionStorage
     */
    BUTTON.addEventListener("click", () => {
        ALERT.classList.remove("weblinx-alert-block--state-active");
        sessionStorage.setItem("alert-hidden", "true");
    }, { passive: true });
}
